import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: 'ng-template[appTabContent]' })
export class TabContentDirective {
    public constructor(public templateRef: TemplateRef<unknown>) {}
}
